import personMathys from './images/mathys/svg/person.svg';
import plusMathys from './images/mathys/svg/plus-lg.svg';
import logoMathys from './images/mathys/png/logo.png';
import arrowDownMathys from './images/mathys/svg/chevron-down.svg';
import arrowLeftMathys from './images/mathys/svg/chevron-left.svg';
import arrowRightMathys from './images/mathys/svg/chevron-right.svg';
import trashMathys from './images/mathys/svg/trash.svg';
import dashMathys from './images/mathys/svg/dash.svg';
import withdrawalMathys from './images/mathys/svg/withdrawal.svg';
import customerAccountMathys from './images/mathys/svg/customer-account.svg';
import personMeziz from './images/meziz/svg/person.svg';
import plusMeziz from './images/meziz/svg/plus-lg.svg';
import logoMeziz from './images/meziz/png/Icon_mezizbet_96x96.png';
import logoMezizLg from './images/meziz/png/Icon_mezizbet_384x384.png';
import arrowDownMeziz from './images/meziz/svg/chevron-down.svg';
import arrowDownMezizCon from './images/meziz/svg/chevron-down-white.svg';
import arrowLeftMeziz from './images/meziz/svg/chevron-left.svg';
import arrowRightMeziz from './images/meziz/svg/chevron-right.svg';
import trashMeziz from './images/meziz/svg/trash.svg';
import dashMeziz from './images/meziz/svg/dash.svg';
import withdrawalMeziz from './images/meziz/svg/withdrawal.svg';
import customerAccountMeziz from './images/meziz/svg/customer-account.svg';
import personLnb from './images/lnb/svg/person.svg';
import plusLnb from './images/lnb/svg/plus-lg.svg';
import logoLnb from './images/lnb/jpeg/logo.jpeg';
import arrowDownLnb from './images/lnb/svg/chevron-down.svg';
import arrowDownLnbCon from './images/lnb/svg/chevron-down-white.svg';
import arrowLeftLnb from './images/lnb/svg/chevron-left.svg';
import arrowRightLnb from './images/lnb/svg/chevron-right.svg';
import trashLnb from './images/lnb/svg/trash.svg';
import dashLnb from './images/lnb/svg/dash.svg';
import withdrawalLnb from './images/lnb/svg/withdrawal.svg';
import customerAccountLnb from './images/lnb/svg/customer-account.svg';

const themeAssets = {
  mathys: {
    person: personMathys,
    plus: plusMathys,
    logo: logoMathys,
    logoLg: logoMathys,
    arrowDownCon: arrowDownMathys,
    arrowDown: arrowDownMathys,
    arrowLeft: arrowLeftMathys,
    arrowRight: arrowRightMathys,
    trash: trashMathys,
    dash: dashMathys,
    withdrawal: withdrawalMathys,
    customerAccount: customerAccountMathys,
  },
  meziz: {
    person: personMeziz,
    plus: plusMeziz,
    logo: logoMeziz,
    logoLg: logoMezizLg,
    arrowDownCon: arrowDownMezizCon,
    arrowDown: arrowDownMeziz,
    arrowLeft: arrowLeftMeziz,
    arrowRight: arrowRightMeziz,
    trash: trashMeziz,
    dash: dashMeziz,
    withdrawal: withdrawalMeziz,
    customerAccount: customerAccountMeziz,
  },
  lnb: {
    person: personLnb,
    plus: plusLnb,
    logo: logoLnb,
    logoLg: logoLnb,
    arrowDownCon: arrowDownLnbCon,
    arrowDown: arrowDownLnb,
    arrowLeft: arrowLeftLnb,
    arrowRight: arrowRightLnb,
    trash: trashLnb,
    dash: dashLnb,
    withdrawal: withdrawalLnb,
    customerAccount: customerAccountLnb,
  },
};

export default themeAssets;
